import React from 'react'
import './Premium.css'

const Premium = () => {
    return (
        <div className='premiumMain'>
            <div className='someText'>
                <h1>Coming Soon</h1>
                <h3>Premium version is mainly for other type of files like .pdf, .mp4 etc.</h3>
            </div>
        </div>
    )
}

export default Premium